module.exports = __webpack_public_path__ + "static/media/hemanshu-team-img-370x370.7c292794.jpg";